export default {
  list: {
    add_orders_btn_cancel: "Cancel",
    add_orders_btn_add: "Add",
    button_add_linehaul: "Add Linehaul",
    "button_download-section-linehauls":
      "Download Linehauls info (Max. {count})",
    "button_download-all-columns": "All Columns",
    "button_download-all-columns-sub":
      "Will download all available columns, including hidden",
    "button_download-current-columns": "Only Visible Columns",
    "button_download-current-columns-sub":
      "Will download just the current visible columns",
    "button_download-status-history": "Status History",
    "button_download-status-history-sub": "Download complete linehaul history",
    "button_download-especific-columns": "Choose Specific Columns",
    "button_download-especific-columns-sub":
      "You'll be able to select the columns of your choice",
    "button_download-orders": "Download Orders Included in Linehaul",
    "button_download-orders-sub": "(Select at least one to activate)",
  },
  detail: {
    delete_linehaul: "Delete Linehaul",
    action_undone:
      "This action can't be undone. Are you sure you want to proceed?",
    delete: "Delete",
    deleting: "Deleting Linehaul",
  },
  creation: {
    title_section_details: "Linehaul Details",
    title_section_dates: "Linehaul dates",
    title_section_additional_info: "Linehaul additional info",
    title_section_observations: "Linehaul observations",
    label_input_type: "Linehaul Type",
    placeholder_type: "Select type",
    label_input_transport: "Linehaul Provider",
    placeholder_combobox: "Select from the list",
    label_input_origin: "Origin Platform",
    placeholder_origin: "Select origin provider",
    label_input_destination: "Destination Platform",
    placeholder_destination: "Select destination provider",
    label_input_date_start: "Pick up Date (optional)",
    placeholder_date_start: "Linehaul starts",
    label_input_date_end: "Delivery Date (optional)",
    placeholder_date_end: "Linehaul ends",
    label_input_cost: "Cost (optional)",
    placeholder_cost: "Insert cost",
    label_input_pallets: "Nº of Pallets",
    placeholder_pallets: "Insert nº pallets",
    label_input_observations: "Observations",
    placeholder_observations: "Add a new observation",
    creation_linehaul: "Creating linehaul",
    btn_cancel: "Cancel",
    btn_save: "Save",
  },
};
